import { ThemeProps } from "../utils/theme";

export const themesWithoutLogin = ['properties.berbergroup.co.uk','properties.mypropertylisting.co.uk','Test Site 1'];

export const doesThemeSkipLogin = (theme: ThemeProps) => !theme?.name? false : themesWithoutLogin.includes(theme.name);